module.exports = __webpack_public_path__ + "img/edge.6fbab089.png";